"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateIOSCertVariantCommand = void 0;
const AbstractCreateVariantCommand_1 = require("./AbstractCreateVariantCommand");
class CreateIOSCertVariantCommand extends AbstractCreateVariantCommand_1.AbstractCreateVariantCommand {
    constructor(api, appId) {
        super(api, appId, 'ios');
        this.withCertificate = (certificate) => {
            this.def.certificate = certificate;
            return this;
        };
        this.withPassphrase = (passphrase) => {
            this.def.passphrase = passphrase;
            return this;
        };
        this.isProduction = () => {
            this.def.production = true;
            return this;
        };
        this.isDevelopment = () => {
            this.def.production = false;
            return this;
        };
        this.withDefinition = (def) => {
            super.withDefinition(def);
            delete this.def['type'];
            return this;
        };
    }
}
exports.CreateIOSCertVariantCommand = CreateIOSCertVariantCommand;
//# sourceMappingURL=CreateIOSCertVariantCommand.js.map